import type { FC } from "react"
import { useMemo } from "react"

import { tokenizeInlineMarkdown } from "@productlane/lib/src/api-reference/inline-markdown"
import { cn } from "@productlane/lib/src/cn"

export const INLINE_CODE_CLASS =
	"rounded-[5px] bg-black/[0.04] px-[0.35em] py-[0.12em] font-mono text-[0.86em] text-primary ring-1 ring-inset ring-black/[0.06] [overflow-wrap:anywhere] dark:bg-white/[0.06] dark:ring-white/[0.08]"

/** A spec description: backtick spans become code, plus **bold** and links. */
export const InlineMarkdown: FC<{ text: string; className?: string }> = ({
	text,
	className,
}) => {
	const tokens = useMemo(() => tokenizeInlineMarkdown(text), [text])
	return (
		<p className={cn("whitespace-pre-line", className)}>
			{tokens.map((token, index) => {
				if (token.kind === "code") {
					return (
						<code key={index} className={INLINE_CODE_CLASS}>
							{token.text}
						</code>
					)
				}
				if (token.kind === "strong") {
					return (
						<strong key={index} className="font-semibold text-primary">
							{token.text}
						</strong>
					)
				}
				if (token.kind === "link") {
					const external = /^https?:/i.test(token.href)
					return (
						<a
							key={index}
							href={token.href}
							{...(external
								? { target: "_blank", rel: "noopener noreferrer" }
								: {})}
							className="font-medium text-primary underline decoration-gray-300 underline-offset-[3px] hover:decoration-current dark:decoration-gray-600"
						>
							{token.text}
						</a>
					)
				}
				return token.text
			})}
		</p>
	)
}
